import { Prism } from "react-syntax-highlighter";
import { vs } from "react-syntax-highlighter/dist/esm/styles/prism";

interface CodeProps {
  className?: string;
  children: string | string[];
  [key: string]: unknown; // This allows for additional props
}

export const Code = ({ className, children, ...props }: CodeProps) => {
    const language = className ? className.replace("lang-", "") : "";
    return (
      <Prism language={language} {...props} style={vs}>
        {children}
      </Prism>
    );
  };
